import { PayProvider, usePayContext } from "@/context/PayContext";
import PayPeriodSelector from "./PayPeriodSelector";
import UnprocessPayDataTable from "./unprocessed-pay-table/UnprocessPayDataTable";
import ProcessedPayDataTable from "./processed-pay-table/ProcessedPayDataTable";
import { months } from "@/utils/date-format";
import { useLocation } from "react-router-dom";
import { GetPayslipUserResult } from "@/models/payslips.model";
import { useEffect } from "react";

function ProcessPayPage() {
  const location = useLocation();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = months[new Date().getMonth()]

  const { year, month } = location.state || {};
  const initialMonth = month ? months[Number(month) - 1] : currentMonth;
  const initialYear = year ? String(year) : currentYear;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PayProvider initialMonth={initialMonth} initialYear={initialYear}>
      <div className="flex flex-col h-max w-full p-4 gap-4">
        <PayPeriodSelector />

        <div className="flex h-[400px] w-full">
          <UnprocessPayDataTable />
        </div>

        <div className="flex h-[400px] w-full">
          <ProcessedPayDataTable />
        </div>
      </div>
    </PayProvider>
  );
}

export default ProcessPayPage;
